import { Theme } from '@mui/material';

const Divider = (theme: Theme) => {
  return {
  };
};

export default Divider;
